import React, { useEffect, useState } from 'react'

import { useAuth } from '@/middlewares/auth/auth-context'
import { hasInvoiceAddress } from '@/utils/invoiceAddress'

const errors = {
    missingStripe: {
        message: 'You still have to connect your Stripe account',
        linkText: 'Connect Stripe',
        linkUrl: import.meta.env.VITE_STRIPE_INTEGRATION,
    },
    missingGeneralSettings: {
        message: 'You still have to complete your organisations settings',
        linkText: 'Complete my informations',
        linkUrl: '/my-account',
    },
}

const getError = (user) => {
    if (user.type !== 'orga') {
        return
    }

    const settings = user.organisation_settings

    if (!settings.stripe?.account_completed) {
        return errors.missingStripe
    } else if (!user.organisation || !settings.phone_number || !hasInvoiceAddress(settings.invoice_address)) {
        return errors.missingGeneralSettings
    }

    return
}

const ModaLStripeInformations = () => {
    const authContext = useAuth()

    const [error, setError] = useState()

    useEffect(() => {
        setError(getError(authContext.user))
    }, [authContext.user])

    if (!error) {
        return <></>
    }
    return (
        <div className="banner-bottom">
            <div className="row mobile-column-100">
                <span style={{ fontSize: '16px', color: 'white' }} className="text-bold white">
                    {error.message}
                </span>
                <a href={error.linkUrl} className="button-banner">
                    {error.linkText}
                </a>
            </div>
        </div>
    )
}

export default ModaLStripeInformations
